import { all, fork, call } from 'redux-saga/effects';
// components
import orderTableWatcherSaga from './common/idb/order/sagas';
import resizeTableWatcherSaga from './common/idb/resize/sagas';
// features
import storageWatcherSaga from './storage/sagas';
import intlWatcherSaga from './features/intl/sagas';
import userWatcherSaga from './features/user/sagas';
import rateWatcherSaga from './features/rate/sagas';
import rolesWatcherSaga from './features/role/sagas';
import ItemsWatcherSaga from './features/item/sagas';
import newDOWatcherSaga from './features/new-do/sagas';
import audit2WatcherSaga from './features/audit2/sagas';
import branchWatcherSaga from './features/branch/sagas';
import quotesWatcherSaga from './features/quotes/sagas';
import localesWatcherSaga from './features/locale/sagas';
import payrollWatcherSaga from './features/payroll/sagas';
import carrierWatcherSaga from './features/carrier/sagas';
import importWatcherSaga from './features/new-import/sagas';
import navbarWatcherSaga from './features/navbar-menu/sagas';
import analyticsWatcherSaga from './features/analytics/sagas';
import rateShopWatcherSaga from './features/rate-shop/sagas';
import SequencesWatcherSaga from './features/sequence/sagas';
import locationsWatcherSaga from './features/location/sagas';
import fleetMapWatcherSaga from './features/fleet-map/sagas';
import cloItemsWatcherSaga from './features/clo-items/sagas';
import ediWatcherSaga from './features/edi-integration/sagas';
import publicCloWatcherSaga from './features/public-clo/sagas';
import fuelCardsWatcherSaga from './features/fuel-cards/sagas';
import fleetListWatcherSaga from './features/fleet-list/sagas';
import ReferencesWatcherSaga from './features/reference/sagas';
import userSettingsWatcherSaga from './features/profile/sagas';
import loadBoardWatcherSaga from './features/load-board/sagas';
import workOrderWatcherSaga from './features/work-order/sagas';
import dashboardsWatcherSaga from './features/dashboards/sagas';
import configWatcherSaga from './features/configurations/sagas';
import liteNewDOWatcherSaga from './features/lite-new-do/sagas';
import AppReleaseWatcherSaga from './features/app-release/sagas';
import carrierEdiWatcherSaga from './features/carrier-edi/sagas';
import iftaReportWatcherSaga from './features/ifta-report/sagas';
import permissionsWatcherSaga from './features/permission/sagas';
import pivotTableWatcherSaga from './features/pivot-table/sagas';
import oAuthPopupWatcherSaga from './features/oauth-popup/sagas';
import newDOQuoteWatcherSaga from './features/new-do-quote/sagas';
import inspectionsWatcherSaga from './features/inspections/sagas';
import tollChargesWatcherSaga from './features/toll-charges/sagas';
import MailSendingWatcherSaga from './features/mail-sending/sagas';
import driversCardWatcherSaga from './features/drivers-card/sagas';
import masterAuditWatcherSaga from './features/master-audit/sagas';
import notificationWatcherSaga from './features/notification/sagas';
import importReportWatcherSaga from './features/import-report/sagas';
import chargeReportWatcherSaga from './features/charge-report/sagas';
import loginWatcherSaga, { sessionSaga } from './features/auth/sagas';
import reportFormatsWatcherSaga from './features/report-format/sagas';
import vendorInvoiceWatcherSaga from './features/invoice/vendor/sagas';
import dispatchGroupWatcherSaga from './features/dispatch-group/sagas';
import carrierPortalWatcherSaga from './features/carrier-portal/sagas';
import serviceVendorWatcherSaga from './features/service-vendor/sagas';
import driverCardsV2WatcherSaga from './features/driver-cards-v2/sagas';
import loadListWatcherSaga from './features/dispatch-report/load/sagas';
import taskManagementWatcherSaga from './features/task-management/sagas';
import customerPortalWatcherSaga from './features/customer-portal/sagas';
import carrierInvoiceWatcherSaga from './features/invoice/carrier/sagas';
import templateReportWatcherSaga from './features/template/report/sagas';
import fleetDocumentsWatcherSaga from './features/fleet-documents/sagas';
import orderListWatcherSaga from './features/dispatch-report/order/sagas';
import availableDriverWatcherSaga from './features/available-driver/sagas';
import customerInvoiceWatcherSaga from './features/invoice/customer/sagas';
import losSubscriptionWatcherSaga from './features/los-subscription/sagas';
import claimManagementWatcherSaga from './features/claim-management/sagas';
import carrierContractsWatcherSaga from './features/contracts/carrier/sagas';
import averageFuelPriceWatcherSaga from './features/average-fuel-price/sagas';
import driverPayrollInvoiceWatcherSaga from './features/invoice/driver/sagas';
import customerContractsWatcherSaga from './features/contracts/customer/sagas';
import customerMasterInvoiceWatcherSaga from './features/master-invoice/sagas';
import compensationGroupWatcherSaga from './features/compensation-group/sagas';
import dashboardsPayrollWatcherSaga from './features/dashboards-payroll/sagas';
import vendorPayrollWatcherSaga from './features/payroll/vendor-payroll/sagas';
import trailerActivityListWatcherSaga from './features/trailer-activity/sagas';
import loadDetailsNewWatcherSaga from './features/dispatch-details/load/sagas';
import dispatchPlannerV2WatcherSaga from './features/dispatch-planner-v2/sagas';
import routeReportListWatcherSaga from './features/dispatch-report/route/sagas';
import containerTypesWatcherSaga from './features/template/container-type/sagas';
import templateInspectionWatcherSaga from './features/template/inspection/sagas';
import orderDetailsNewWatcherSaga from './features/dispatch-details/order/sagas';
import configPagesWatcherSaga from './features/configurations/config-pages/sagas';
import geoFencingLocationWatcherSaga from './features/geo-fencing-location/sagas';
import routeMassCreateReportSaga from './features/route-mass-create-report/sagas';
import fleetProfileSimpleWatcherSaga from './features/fleet-profile-simple/sagas';
import centralizedDispatchWatcherSaga from './features/centralized-dispatch/sagas';
import normalizeCurrencyWatcherSaga from './features/normalize-currency-list/sagas';
import carrierStatisticWatcherSaga from './features/carrier-statistic-report/sagas';
import loadPlannerTemplateWatcherSaga from './features/load-planner-template/sagas';
import commissionAssignmentWatcherSaga from './features/commission-assignment/sagas';
import serviceVendorInvoiceWatcherSaga from './features/invoice/service-vendor/sagas';
import fleetVisitPagesWatcherSaga from './features/fleet-list/sagas/visit-page-sagas';
import ratingGeoFencingZoneWatcherSaga from './features/geo-fencing-zone/rating/sagas';
import reportGeoFencingZoneWatcherSaga from './features/geo-fencing-zone/report/sagas';
import CarrierRatingReportListWatcherSaga from './features/carrier-rating-report/sagas';
import CarrierInsurancesReportListWatcherSaga from './features/carrier/insurances/sagas';
import carrierRateRequestWatcherSaga from './features/carrier-rate-request-report/sagas';
import stylingWatcherSaga, { getInitialSplashScreenSaga } from './features/styling/sagas';
import dispatchPlannerEventsV2WatcherSaga from './features/dispatch-planner-events-v2/sagas';
import equipmentServiceInvoiceWatcherSaga from './features/equipment-service-invoice/sagas';
import telEventsReportListWatcherSaga from './features/dispatch-report/load/load-events/sagas';
import telByCloReportListWatcherSaga from './features/dispatch-report/load/load-by-order/sagas';
import cloByTelReportListWatcherSaga from './features/dispatch-report/order/order-by-load/sagas';
import routeByLoadReportListWatcherSaga from './features/dispatch-report/route/route-by-load/sagas';
// new dispatch board
import dispatchBoardSaga from './features/dispatch-board/sagas';
import dispatchBoardTelSaga from './features/dispatch-board/load/sagas';
import dispatchBoardCloSaga from './features/dispatch-board/order/sagas';
// sockets
import socketWatcherSaga from './features/sockets/sagas';
// fleet-profile
import fleetProfileWatcherSaga from './features/fleet-profile/sagas';
// carrier-profile
import carrierProfileWatcherSaga from './features/carrier-profile/sagas';
// forms
import TemplateSearchWatcherSaga from './forms/forms/template-search/sagas';
// helpers/constants
import { getAuthTokenFromSession } from './helpers';
// sagas
import { GlobalActionsWatcherSaga } from './sagas/global-actions-saga';
import { initialDataWatcherSaga, watchSwitchBranchSuccess } from './sagas/initial-data-saga';
////////////////////////////////////////////////

export default function* mainSaga() {
  yield all([
    fork(ediWatcherSaga),
    fork(intlWatcherSaga),
    fork(userWatcherSaga),
    fork(rateWatcherSaga),
    fork(newDOWatcherSaga),
    fork(loginWatcherSaga),
    fork(rolesWatcherSaga),
    fork(ItemsWatcherSaga),
    fork(audit2WatcherSaga),
    fork(navbarWatcherSaga),
    fork(branchWatcherSaga),
    fork(configWatcherSaga),
    fork(importWatcherSaga),
    fork(quotesWatcherSaga),
    fork(stylingWatcherSaga),
    fork(carrierWatcherSaga),
    fork(payrollWatcherSaga),
    fork(localesWatcherSaga),
    fork(storageWatcherSaga),
    fork(analyticsWatcherSaga),
    fork(loadListWatcherSaga),
    fork(fleetMapWatcherSaga),
    fork(rateShopWatcherSaga),
    fork(cloItemsWatcherSaga),
    fork(publicCloWatcherSaga),
    fork(orderListWatcherSaga),
    fork(fleetListWatcherSaga),
    fork(SequencesWatcherSaga),
    fork(locationsWatcherSaga),
    fork(loadBoardWatcherSaga),
    fork(fuelCardsWatcherSaga),
    fork(liteNewDOWatcherSaga),
    fork(workOrderWatcherSaga),
    fork(pivotTableWatcherSaga),
    fork(ReferencesWatcherSaga),
    fork(AppReleaseWatcherSaga),
    fork(iftaReportWatcherSaga),
    fork(carrierEdiWatcherSaga),
    fork(newDOQuoteWatcherSaga),
    fork(dashboardsWatcherSaga),
    fork(oAuthPopupWatcherSaga),
    fork(orderTableWatcherSaga),
    fork(resizeTableWatcherSaga),
    fork(driversCardWatcherSaga),
    fork(driverCardsV2WatcherSaga),
    fork(permissionsWatcherSaga),
    fork(MailSendingWatcherSaga),
    fork(initialDataWatcherSaga),
    fork(tollChargesWatcherSaga),
    fork(configPagesWatcherSaga),
    fork(inspectionsWatcherSaga),
    fork(masterAuditWatcherSaga),
    fork(chargeReportWatcherSaga),
    fork(userSettingsWatcherSaga),
    fork(notificationWatcherSaga),
    fork(importReportWatcherSaga),
    fork(vendorInvoiceWatcherSaga),
    fork(GlobalActionsWatcherSaga),
    fork(reportFormatsWatcherSaga),
    fork(watchSwitchBranchSuccess),
    fork(dispatchGroupWatcherSaga),
    fork(centralizedDispatchWatcherSaga),
    fork(carrierPortalWatcherSaga),
    fork(vendorPayrollWatcherSaga),
    fork(serviceVendorWatcherSaga),
    fork(containerTypesWatcherSaga),
    fork(TemplateSearchWatcherSaga),
    fork(carrierInvoiceWatcherSaga),
    fork(customerPortalWatcherSaga),
    fork(loadDetailsNewWatcherSaga),
    fork(templateReportWatcherSaga),
    fork(routeMassCreateReportSaga),
    fork(taskManagementWatcherSaga),
    fork(fleetDocumentsWatcherSaga),
    fork(fleetVisitPagesWatcherSaga),
    fork(customerInvoiceWatcherSaga),
    fork(dispatchPlannerV2WatcherSaga),
    fork(availableDriverWatcherSaga),
    fork(orderDetailsNewWatcherSaga),
    fork(routeReportListWatcherSaga),
    fork(losSubscriptionWatcherSaga),
    fork(claimManagementWatcherSaga),
    fork(carrierStatisticWatcherSaga),
    fork(averageFuelPriceWatcherSaga),
    fork(carrierContractsWatcherSaga),
    fork(customerContractsWatcherSaga),
    fork(dashboardsPayrollWatcherSaga),
    fork(normalizeCurrencyWatcherSaga),
    fork(compensationGroupWatcherSaga),
    fork(telByCloReportListWatcherSaga),
    fork(templateInspectionWatcherSaga),
    fork(carrierRateRequestWatcherSaga),
    fork(geoFencingLocationWatcherSaga),
    fork(cloByTelReportListWatcherSaga),
    fork(fleetProfileSimpleWatcherSaga),
    fork(telEventsReportListWatcherSaga),
    fork(loadPlannerTemplateWatcherSaga),
    fork(trailerActivityListWatcherSaga),
    fork(driverPayrollInvoiceWatcherSaga),
    fork(commissionAssignmentWatcherSaga),
    fork(serviceVendorInvoiceWatcherSaga),
    fork(ratingGeoFencingZoneWatcherSaga),
    fork(reportGeoFencingZoneWatcherSaga),
    fork(customerMasterInvoiceWatcherSaga),
    fork(dispatchPlannerEventsV2WatcherSaga),
    fork(routeByLoadReportListWatcherSaga),
    fork(equipmentServiceInvoiceWatcherSaga),
    fork(CarrierRatingReportListWatcherSaga),
    fork(CarrierInsurancesReportListWatcherSaga),
    // new dispatch board
    fork(dispatchBoardSaga),
    fork(dispatchBoardTelSaga),
    fork(dispatchBoardCloSaga),
    // fleet-profile
    fork(fleetProfileWatcherSaga),
    // carrier-profile
    fork(carrierProfileWatcherSaga),
    // sockets
    fork(socketWatcherSaga),
  ]);

  const token = yield call(getAuthTokenFromSession);

  yield call(sessionSaga, token);
  yield call(getInitialSplashScreenSaga);
}
